import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { StaffDisputeSummary } from '../../services/staff-dispute.service';
import { DisputeStatusBadgeComponent } from './dispute-status-badge.component';

@Component({
    selector: 'app-dispute-claims-table',
    standalone: true,
    imports: [CommonModule, DatePipe, TableModule, ButtonModule, DisputeStatusBadgeComponent],
    template: `
        <div class="dispute-card claims-table-wrap">
            <p-table
                [value]="disputes"
                [paginator]="true"
                [rows]="8"
                [rowsPerPageOptions]="[8, 15, 25]"
                responsiveLayout="scroll"
                styleClass="dispute-table"
                [rowHover]="true"
                selectionMode="single"
                [(selection)]="selectedRow"
                (onRowSelect)="onRowSelect($event)"
                dataKey="claimNumber"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Claim ID</th>
                        <th>Order ID</th>
                        <th>Customer</th>
                        <th>Status</th>
                        <th>Qty</th>
                        <th>Created</th>
                        <th class="actions-col">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row" [class.row-active]="row.claimNumber === activeClaimNumber">
                        <td class="claim-cell">{{ row.claimNumber }}</td>
                        <td>{{ row.orderNumber }}</td>
                        <td>{{ row.customerName || row.customerId || '—' }}</td>
                        <td><app-dispute-status-badge [status]="row.status"></app-dispute-status-badge></td>
                        <td>{{ row.totalClaimQty || 0 }}</td>
                        <td class="created-cell">{{ row.createdAt | date: 'MMM d, y, h:mm a' }}</td>
                        <td class="actions-col">
                            <button
                                pButton
                                type="button"
                                icon="pi pi-eye"
                                label="View"
                                size="small"
                                severity="secondary"
                                (click)="view.emit(row.claimNumber); $event.stopPropagation()"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="empty-cell">No disputes found for the selected date range or filters.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    `,
    styles: [
        `
            .claims-table-wrap {
                padding: 0;
                overflow: hidden;
            }
            .actions-col {
                width: 7rem;
                text-align: right;
            }
            .claim-cell {
                font-weight: 700;
            }
            .created-cell {
                white-space: nowrap;
                font-size: 0.85rem;
                color: var(--dispute-muted, var(--text-color-secondary));
            }
            .empty-cell {
                text-align: center;
                padding: 2rem !important;
                color: var(--dispute-muted, var(--text-color-secondary));
            }
        `
    ]
})
export class DisputeClaimsTableComponent implements OnChanges {
    @Input({ required: true }) disputes: StaffDisputeSummary[] = [];
    @Input() activeClaimNumber = '';
    @Output() view = new EventEmitter<string>();

    selectedRow: StaffDisputeSummary | null = null;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['activeClaimNumber'] || changes['disputes']) {
            this.selectedRow =
                this.disputes.find((d) => d.claimNumber === this.activeClaimNumber) || null;
        }
    }

    onRowSelect(event: TableRowSelectEvent<StaffDisputeSummary>): void {
        const row = event.data;
        if (!row || Array.isArray(row)) {
            return;
        }
        this.view.emit(row.claimNumber);
    }
}
